// extracted by mini-css-extract-plugin
export default {"main":"main__OHeVx","head":"head__N-uLf","info-box":"info-box__pTQrs"};